import axios from 'axios';
import { handleApiUnauthorized } from '@/utils/sessionExpiry';

let baseURL = 'https://indiefy.net/v1/';

if (location.href.includes('localhost')) {
  baseURL = 'http://localhost:3000/v1/';
}

// Create axios instance with base configuration
const api = axios.create({
  baseURL: baseURL,
  withCredentials: true, // Required for all API calls
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Response interceptor for handling common errors
api.interceptors.response.use(
  response => response,
  async error => {
    if (error.response) {
      if (error.response.status === 401) {
        console.warn('Unauthorized API request:', error.config?.url);
        await handleApiUnauthorized(error);
      } else if (error.response.status === 403) {
        console.warn('Forbidden API request:', error.config.url);
      } else if (error.response.status === 404) {
        console.warn('Resource not found:', error.config.url);
      } else if (error.response.status >= 500) {
        console.error('Server error:', error.response.status, error.config.url);
      }
    } else if (error.request) {
      console.error(
        'Network Error - no response received:',
        error.config?.url || 'unknown endpoint',
      );
    } else {
      console.error('API Request Error:', error.message);
    }
    return Promise.reject(error);
  },
);

export default api;